export type ManagerAccount = {
  managerAccountId: string;
  managerAccountName: string;
};

export type AdvertiserAccountResponse = {
  accountId: string;
  accountName: string;
  managerAccountId: string;
  managerAccountIdList: string[];
};

export type AdvertiserAccount = {
  advertiserAccountId: string;
  advertiserAccountName: string;
  managerAccountIdList: string[];
};

const ACCOUNT_TYPES = ['MANAGER_ACCOUNT', 'ADVERTISER_ACCOUNT'] as const;
export type AccountType = (typeof ACCOUNT_TYPES)[number];

const ACCESS_SCOPES = ['DIRECT_ONLY', 'FULL_HIERARCHY'] as const;
export type AccessScope = (typeof ACCESS_SCOPES)[number];

export type PathAccount = {
  accountId: string;
  accountName: string;
};

export type Account = {
  accountId: string;
  accountName: string;
  accountType: AccountType;
  pathFromRoot?: PathAccount[];
  isMTAFeatureEnabled?: string;
};

export type AccountTree = Account & {
  links: string[];
  descendantAdvertisers: string[];
  descendantManagers: string[];
  immediateParents: PathAccount[];
};

export type FullAccountHierarchy = {
  rootAccounts: AccountTree[];
  accountsTreeById: Record<string, AccountTree>;
  advertiserAccountIds: string[];
  managerAccountIds: string[];
  isMTAFeatureEnabled?: string;
};

export enum AccountsError {
  MAX_ACCOUNTS_ADVERTISERS_SUPPORTED = 'MAX_ACCOUNTS_ADVERTISERS_SUPPORTED',
  MAX_MANAGER_ACCOUNTS_SUPPORTED = 'MAX_MANAGER_ACCOUNTS_SUPPORTED',
  MAX_ADVERTISERS_ACCOUNTS_SUPPORTED = 'MAX_ADVERTISERS_ACCOUNTS_SUPPORTED'
}
